import type { IconProps } from './types';

export const CenterAlignIcon = (props: IconProps) => {
  const {
    size = 24,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M19.5 17.4599L19.5771 17.4638C19.9551 17.5024 20.25 17.8218 20.25 18.2099C20.25 18.5981 19.9551 18.9174 19.5771 18.956L19.5 18.9599H5C4.58579 18.9599 4.25 18.6241 4.25 18.2099C4.25004 17.7957 4.58581 17.4599 5 17.4599H19.5ZM15.75 11.25L15.8271 11.2539C16.2051 11.2925 16.5 11.6118 16.5 12C16.5 12.3881 16.2051 12.7074 15.8271 12.7461L15.75 12.75H8.25C7.83579 12.75 7.5 12.4142 7.5 12C7.50002 11.5858 7.8358 11.25 8.25 11.25H15.75ZM20.5 5.04C20.9142 5.04 21.25 5.37579 21.25 5.79C21.25 6.20421 20.9142 6.54 20.5 6.54H3.5C3.08579 6.54 2.75 6.20421 2.75 5.79C2.75 5.37579 3.08579 5.04 3.5 5.04H20.5Z"
        fill={color}
      />
    </svg>
  );
};
